module.exports = __webpack_public_path__ + "fonts/Sarabun-SemiBoldItalic.0232e23c.ttf";